import { postAnalytics } from "./postAnalytics";

const api = import.meta.env.VITE_API_URL;

type IdleRequestCallback = (deadline: { didTimeout: boolean; timeRemaining: () => number }) => void;

const scheduleIdle = (fn: () => void): void => {
  const ric = (
    window as Window & {
      requestIdleCallback?: (cb: IdleRequestCallback, opts?: { timeout: number }) => number;
    }
  ).requestIdleCallback;

  if (typeof ric === "function") {
    ric(
      () => {
        fn();
      },
      { timeout: 2500 },
    );
    return;
  }
  window.setTimeout(fn, 0);
};

export const trackLocalPageView = (path: string): void => {
  try {
    if (!api) return;

    scheduleIdle(() => {
      postAnalytics(`${api}/analytics/visit`, JSON.stringify({ path }));
    });
  } catch {
    // Ignore analytics failures completely.
  }
};
